import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'addLimiter'
})
export class AddLimiterPipe implements PipeTransform {

  transform(value: unknown, ...args: any[]): unknown {
    if(args[0].length > 0) {
      let newArr = args[0].map((element, i) => {
        console.log(args[0].length - 1);
        if(i < (args[0].length - 1)) {
          return element = element + '&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;';
          console.log(element);
        }
        return element
      });
      console.log(newArr);
      return newArr;
    }
    return null
  }

}
